import React, { useState } from "react";
import "../Footer/footer.css";
import { Col, Container, Row, ListGroup } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const Footer = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (typeof window !== "undefined") {
    window.addEventListener("scroll", toggleVisible);
  }

  return (
    <>
      <footer className="pt-5">
        <Container>
          <Row>
            <Col md="4" sm="12" className="quick_link mt-3 mt-md-0 ">
              <NavLink to="/">
                <img
                  src="assets/images/WhatsApp_Image_2025-03-03_at_5.56.39_PM-removebg-preview.png"
                  alt="Weekendmonks Logo"
                  className="logo-img"
                />
              </NavLink>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <NavLink to="/">
                    <p className="message mt-4">
                      🌍 Explore the World with Us! Special Offers Available Now! ✈️
                    </p>
                  </NavLink>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col md="4" sm="12" className="quick_link mt-3 mt-md-0 ">
              <h4 className="mt-lg-0 mt-sm-3">Quick Link </h4>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <NavLink to="/">
                    <i className="bi bi-arrow-right-circle me-2"></i> Home
                  </NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/about-us">
                    <i className="bi bi-arrow-right-circle me-2"></i> About Us
                  </NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/tours">
                    <i className="bi bi-arrow-right-circle me-2"></i> Tours
                  </NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/gallery">
                    <i className="bi bi-arrow-right-circle me-2"></i> Gallery
                  </NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/contact-us">
                    <i className="bi bi-arrow-right-circle me-2"></i> Contact Us
                  </NavLink>
                </ListGroup.Item>
              </ListGroup>
               <ListGroup.Item>
    <NavLink to="/privacy-policy">
      <i className="bi bi-arrow-right-circle me-2"></i> Privacy Policy
    </NavLink>
  </ListGroup.Item>
  <ListGroup.Item>
    <NavLink to="/terms-and-conditions">
      <i className="bi bi-arrow-right-circle me-2"></i> Terms & Conditions
    </NavLink>
  </ListGroup.Item>
            </Col>
            <Col md="4" sm="12" className="location mt-3 mt-md-0 ">
              <h4 className="mt-lg-0 mt-sm-3">Contact Info </h4>
              <div className="d-flex align-items-center">
                <p className="pb-2">A-114 Sobo Center, South Bopal, Ahmedabad 380058</p>
              </div>
              <div className="d-flex flex-column my-2">
  <div className="d-flex align-items-center mb-2">
    <i className="bi bi-envelope me-2" style={{ color: "orange" }}></i>
    <a target="_blank" href="mailto:bookings@aroundtheglobe.co.in" className="text-decoration-none ">
      bookings@aroundtheglobe.co.in
    </a>
  </div>
  <div className="d-flex align-items-center">
    <i className="bi bi-telephone me-2" style={{ color: "orange" }}></i>
    <a target="_blank" href="tel:8487900695" className="text-decoration-none ">
      +91 84879 00695
    </a>
  </div>
</div>

            </Col>
          </Row>
          <Row className="py-2 bdr mt-3">
            <Col className="col copyright d-flex flex-column flex-md-row justify-content-between text-center text-md-start">
              <p className="text-light mb-1 mb-md-0">© 2024. AroundTheGlobe All rights reserved</p>
              <p className="text-light mb-0">Developed by LiftTraffic</p>
            </Col>
          </Row>
        </Container>
      </footer>

      <div id="back-top" onClick={scrollTop} className={visible ? "active" : ""}>
        <img
          src="/assets/images/biplane.png" // Replace with the path to your image
          alt="Back to top"
          style={{ width: "30px", height: "30px" }} // Adjust size as needed
        />
      </div>
    </>
  );
};

export default Footer;
